import React from 'react';

import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

import {AT_RISK_STEP_ID, STEP_PROGRESS} from '../constants';
import {AT_RISK_HELP_CTA} from '../events';
import {StepLayout} from '../step-layout.react-component';
import styles from './response-step.module.less';

import type {StepRendererProps} from '../types';

export function ABitStuckStep({dispatch, onClose, onTrackEventClick}: StepRendererProps) {
    const {gettext} = useI18n();

    const tips = [
        <LocalizedHtml
            key={0}
            html={gettext(
                '<strong class="bold">Slow down.</strong> You are on the verge of something new. Go back to review the example and trace it one step at a time. Then attempt the practice question. Doing it sometimes reveals what watching did not.',
            )}
            interpolate={{bold: <strong className="ud-text-bold" />}}
        />,
        gettext(
            "Ask the course community where you're stuck using the Q&A option. You might be surprised how much other learners (or your instructor) are willing to help.",
        ),
        gettext(
            "As a subscriber you have access to thousands of courses and each instructor's teaching style is different. If this course isn't working for you try another course on the topic.",
        ),
    ];

    return (
        <StepLayout
            progressValue={STEP_PROGRESS[AT_RISK_STEP_ID.A_BIT_STUCK]}
            onClose={onClose}
            footerLeftChildren={
                <Button
                    udStyle="ghost"
                    size="medium"
                    onClick={() =>
                        dispatch({type: 'STEP_ADVANCED', nextStepId: AT_RISK_STEP_ID.INITIAL})
                    }
                >
                    {gettext('Back')}
                </Button>
            }
            footerRightChildren={
                <Button
                    udStyle="primary"
                    size="medium"
                    componentClass="a"
                    href="/courses/search/"
                    onClick={() => onTrackEventClick(AT_RISK_HELP_CTA.EXPLORE_COURSES)}
                >
                    {gettext('Explore courses')}
                </Button>
            }
        >
            <div className={styles['content']}>
                <h2 className="ud-heading-xl">{gettext("You're not alone on this one.")}</h2>
                <ol className={styles['tips']}>
                    {tips.map((tip, i) => (
                        <li key={i} className="ud-text-md">
                            {tip}
                        </li>
                    ))}
                </ol>
            </div>
        </StepLayout>
    );
}
